import { createSelector } from 'reselect';

const constructionSelector = (state) => state.Construction;

export default createSelector(
  constructionSelector,
  (construction) => ({
    loaded: construction.parameters_loaded,
    available: [...construction.available.structure],
    info: construction.info.structure,
    selected: construction.selected.structure
  })
);
